import { render, staticRenderFns } from "./CardImg.vue?vue&type=template&id=6aeb6c78&scoped=true&"
import script from "./CardImg.vue?vue&type=script&lang=js&"
export * from "./CardImg.vue?vue&type=script&lang=js&"
import style0 from "./CardImg.vue?vue&type=style&index=0&id=6aeb6c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeb6c78",
  null
  
)

export default component.exports